import { Component, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { RootScopeService } from '../../../core/shared-service/root-scope.service';
import { RootScopeDeclare } from '../../../core/rootscope-declare';
import { DashboardService } from '../../services/dashboard.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { IHeatmap, HeatmapFloorListObject} from '../../services/heatmap.service.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-heatmap-snap-shot',
  templateUrl: './heatmap-snap-shot.component.html',
  styleUrls: ['./heatmap-snap-shot.component.css'],
})
export class HeatmapSnapShotComponent implements OnInit, OnDestroy {
  heatMapData: IHeatmap;
  currentFloor: HeatmapFloorListObject;
  rootScopeData: RootScopeDeclare;
  floorsList: HeatmapFloorListObject[];
  activeFloorIndex: number;
  dataCollectedDate: Date;
  floorNameList: Array<string> = [];
  currentFacilityId: String;

  // subscriptions
  private _facilityOnChange: Subscription;
  private _heatMapDataOnChange: Subscription;

  constructor(
    private rootScopeService: RootScopeService,
    private dashboardService: DashboardService,
    private elementRef: ElementRef,
    private _facilityService: FacilityService
  ) {
    this.getRootScopeData();
  }

  getRootScopeData(): void {
    this.rootScopeService.getRootScope().subscribe(rootScopeData => {
      this.rootScopeData = rootScopeData;
    });
  }

  ngOnInit() {
    this._heatMapDataOnChange = this.dashboardService.heatMapDataSource.subscribe(res => {
      this.afterGetHeatMapData(res);
    });
    
    // subscript facility change / when facility change
    this.currentFacilityId = this._facilityService.selectedFacilityId();
    this._facilityOnChange = this._facilityService.selectedFacilitySource.subscribe(res => {
      this.currentFacilityId = res.facilityId;
      this.dashboardService.getHeatMapData();
    });

    if (this.currentFacilityId) {
      this.dashboardService.getHeatMapData();
    }
  }

  ngOnDestroy() {
    // distryo subscriber
    if (this._facilityOnChange) {
      this._facilityOnChange.unsubscribe();
    }

    if (this._heatMapDataOnChange) {
      this._heatMapDataOnChange.unsubscribe();
    }
  }

  afterGetHeatMapData(data: IHeatmap) {
    this.heatMapData = data;
    this.currentFloor = this.heatMapData.floors[0];
    // if only date available
    if (this.heatMapData.dataCollectedAt) {
      this.dataCollectedDate = new Date(parseInt(this.heatMapData.dataCollectedAt, 10));
    }

    this.setFloorNameList();
    this.changeFloor(0);
  }

  setFloorNameList() {
    this.floorNameList = this.heatMapData.floors.map((floor: { floorName: string; }) => {
      return floor.floorName;
    });
  }

  // getDataCollectedDate(timeStamp: number) {
  //   const dateAndTime = new Date(timeStamp);
  //   const dd = dateAndTime.getDate();
  //   const mm = dateAndTime.getMonth();
  //   const yy = dateAndTime.getFullYear().toString().substr(-2);
  //   this.dataCollectedDate = mm + '/' + dd + '/' + yy;
  // }

  changeFloor(ind: number) {
    this.activeFloorIndex = ind;
    this.floorsList = this.heatMapData.floors;
    this.currentFloor = this.floorsList[this.activeFloorIndex];    
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (
        document.querySelector('.heatMapOuterCntr--mobile') &&
        localStorage.getItem('showHeatMapSection') &&
        this.rootScopeData.deviceType === 'phone'
      ) {
        this.elementRef.nativeElement.scrollIntoView({ behavior: 'smooth' });
        localStorage.setItem('showHeatMapSection', '');
      }
    }, 5000);
  }
}
